"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["spacing", "gutterBottom", "children", "className", "appendedComponents"];

var ListGroup = function ListGroup(props) {
  var _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? '4px' : _props$spacing,
      gutterBottom = props.gutterBottom,
      children = props.children,
      className = props.className,
      appendedComponents = props.appendedComponents,
      restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var spacingClassPostfix = spacing.replace('px', '');
  return (0, _preact.h)("ul", (0, _extends2.default)({
    className: (0, _classnames.default)(className, 'list-group', "list-group--spacing".concat(spacingClassPostfix), {
      'list-group--gutter-bottom': gutterBottom
    })
  }, restProps), props.children.map(function (child, index) {
    return (0, _preact.h)("li", {
      key: index
    }, child);
  }), appendedComponents);
};

var _default = ListGroup;
exports.default = _default;